import * as React from 'react'
import { UsersListPage } from '@/modules/users/pages'

interface Props {
  companyId: string
}

const CompanyUsersPanel: React.FC<Props> = ({ companyId }) => (
  <div className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col">
    <UsersListPage companyId={companyId} />
  </div>
)

export default CompanyUsersPanel
